module.exports = __webpack_public_path__ + "54cf98f5/img/dollar-icon.35c9d638.svg";